import { render, staticRenderFns } from "./ConsentAdditional.vue?vue&type=template&id=136fe44a&scoped=true&"
import script from "./ConsentAdditional.vue?vue&type=script&lang=js&"
export * from "./ConsentAdditional.vue?vue&type=script&lang=js&"
import style0 from "./ConsentAdditional.vue?vue&type=style&index=0&id=136fe44a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136fe44a",
  null
  
)

export default component.exports